/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcTradereportingV1BlueSheetState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_TRADEREPORTING_V1_BLUE_SHEET_STATE_ENTITY_NAME = 'ixc.tradereporting.v1.BlueSheet';
export const ixcTradereportingV1BlueSheetStateEntity = new schema.Entity<IxcTradereportingV1BlueSheetState>(IXC_TRADEREPORTING_V1_BLUE_SHEET_STATE_ENTITY_NAME, {}, { idAttribute: 'reportId' });

